// extracted by mini-css-extract-plugin
module.exports = {"main":"modal_main__Olgqs","nav":"modal_nav__A812y","content":"modal_content__B75Bw","ul":"modal_ul__Zifvz","li":"modal_li__i498o"};